import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import PenerimaanPasienBaruRanapSvc from "@/services/PenerimaanPasienBaruRanap";

@Module({ store, dynamic: true, namespaced: true, name: "penerimaan-pasien-baru-ranap" })
class PenerimaanPasienBaruRanapModule extends VuexModule {
  penerimaan: any = null;
  loading = false;

  @Mutation SET_PENERIMAAN(val: any) {
    this.penerimaan = val;
  }

  @Mutation SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action async getByRegister(reg: string | number) {
    this.SET_LOADING(true);
    try {
      const dt = await PenerimaanPasienBaruRanapSvc.getByRegister(reg);
      const { data } = dt.data;
      this.SET_PENERIMAAN(data);
    } catch {
      this.SET_PENERIMAAN(null);
    }
    this.SET_LOADING(false);
  }

  @Action async refresh(id: number) {
    this.SET_LOADING(true);
    try {
      const dt = await PenerimaanPasienBaruRanapSvc.find(id);
      const { data } = dt.data;
      this.SET_PENERIMAAN(data);
    } catch {
      this.SET_PENERIMAAN(null);
    }
    this.SET_LOADING(false);
  }

  @Action reset() {
    this.SET_PENERIMAAN(null);
  }
}

export const storePenerimaanPasienBaruRanap = getModule(PenerimaanPasienBaruRanapModule);
